import { ApiRequestConfig } from 'api';
import { get } from 'features/api';
import { GetModelResponse } from 'types/page-model';
import { FetchModelProps } from '../types';

export const fetchModel = (params: FetchModelProps, options: ApiRequestConfig) =>
  get<GetModelResponse>('get-model', params, options);
